<ng-template #field>
    <input
        id="{{ id }}"
        type="text"
        class="form-control"
        [class.is-invalid]="ngControl.invalid && ngControl.touched"
        [formControl]="formControl"
        [ngbTypeahead]="search"
        [focusFirst]="false"
        (blur)="onBlur()"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        #instance="ngbTypeahead" />
    @if (ngControl.control != null) {
        <app-control-messages [control]="ngControl.control" />
    }
</ng-template>

@if (gridLayout) {
    <div class="form-group row" [class.select-style]="selectStyle">
        @if (labelCols > 0) {
            <label class="col-form-label" [class]="labelClass" [for]="id">
                {{ label }}
            </label>
        }
        <div [class]="inputColsClass">
            <ng-container [ngTemplateOutlet]="field" />
        </div>
    </div>
} @else {
    <div [ngClass]="{'mb-3': label.length > 0}" [class.select-style]="selectStyle">
        @if (label.length > 0) {
            @if (labelCols > 0) {
                <label class="form-label" [class]="labelClass" [for]="id">
                    {{ label }}
                </label>
            }
        }
        <ng-container [ngTemplateOutlet]="field" />
    </div>
}
